import React from 'react';
import './current-regulations.scss';

const CurrentRegulations = () => {
  return (
      <iframe src="https://mpgi.gov.hr/print2.aspx?id=8630&url=print&page=1" className="container-fluid view-container"></iframe>
  );
}

export default CurrentRegulations;
